mutation SetSceneElements($eventId: ID!, $overlayId: ID!, $sceneId: ID!, $elements: [StreamToolsSceneElementInput!]!) {
  scene: StreamToolsSetSceneElements(eventId: $eventId, overlayId: $overlayId, sceneId: $sceneId, elements: $elements) {
    sceneId
    overlayId
    eventId
    name
    version
    createdAt
    elements {
      elementKind
      elementId
      x
      y
      z
      scale
      visible
      w
      h
    }
  }
}
